import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const TranscriptomicsPage = () => {
  return <TechnicalServicePage serviceKey="transcriptomics" />
}

export default TranscriptomicsPage